/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-table[_ngcontent-%COMP%]{border-left:1px solid #ddd;border-right:1px solid #ddd;border-top:1px solid #ddd}.mat-row[_ngcontent-%COMP%]   .mat-cell[_ngcontent-%COMP%]{border-bottom:1px solid #ddd;background-color:#ececec}.mat-row[_ngcontent-%COMP%]:hover{background-color:red}"];
export { styles as styles };
